/** Short subtitle (emails, headers) */
export const SITE_TAGLINE_SHORT = 'Purveyor of fine fiddle tunes since 1979';

/** Full brand line shown in footer and home loading UI */
export const SITE_TAGLINE =
  'Cranford Publications: Purveyor of fine fiddle tunes since 1979.';

/** Alternate format with dash separator */
export const SITE_TAGLINE_WITH_DASH =
  'Cranford Publications - Purveyor of fine fiddle tunes since 1979';
